import React from "react";
import "../styles/Portfolio.css";

const projects = [
  { id: 1, title:"Residential (Franklin Cove Apartment)", image: "/project/project4.jpg" },
  { id: 2, title:"Commercial ", image: "/project/project5.jpg" },
  { id: 3, title:"Entertairment", image: "/project/project3.jpg" },
  { id: 4, title:"Goverment", image: "/project/project2.jpg" },
  { id: 5, title:"School", image: "/project/project1.jpg" },
  // { id: 6, title: 'Community Center', image: '/project/project6.jpg' },
];

const Portfolio = () => {
  return (
    <div className="portfolio-page">
      <h2 className="portfolio-heading"> Our Projects</h2>
      {/* Intro Section */}
      <div className="portfolio-intro">
        <div className="portfolio-intro-image">
          <img src="/project/projectheader.jpg" alt="Teamphoto" />
        </div>
        <div className="portfolio-intro-text">
          <h2>Portfolio</h2>
          <p>
            TMC Construction specializes in construction management, general
            contracting, and design-build services. In addition, we also provide
            expertise in civil construction, asphalt and concrete works, storage
            facility development, and real estate development. Below is a
            sampling of our recent portfolio showcasing the diversity and
            quality of our work.
          </p>
        </div>
      </div>

      {/* Grid Section */}
      <div className="portfolio-grid">
        {projects.map((project) => (
          <div key={project.id} className="portfolio-item">
            <img
              src={project.image}
              alt={project.title}
              className="portfolio-image"
            />
            <p className="portfolio-title">{project.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Portfolio;
